"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterProperties = exports.makeQueryFilter = exports.QueryFilter = exports.Resource = exports.Timestamps = exports.ResourceId = exports.ObjectId = exports.date = exports.buffer = void 0;
const t = __importStar(require("ts-codec"));
const bson = __importStar(require("bson"));
exports.buffer = t.codec('Buffer', (buffer) => {
    if (!Buffer.isBuffer(buffer)) {
        throw new t.TransformError([`Expected buffer but got ${typeof buffer}`]);
    }
    return buffer.toString('base64');
}, (buffer) => Buffer.from(buffer, 'base64'));
exports.date = t.codec('Date', (date) => {
    if (!(date instanceof Date)) {
        throw new t.TransformError([`Expected Date but got ${typeof date}`]);
    }
    return date.toISOString();
}, (date) => {
    const parsed = new Date(date);
    if (isNaN(parsed.getTime())) {
        throw new t.TransformError([`Invalid date`]);
    }
    return parsed;
});
const assertObjectId = (value) => {
    if (!bson.ObjectId.isValid(value)) {
        throw new t.TransformError([`Expected an ObjectId but got ${typeof value}`]);
    }
};
exports.ObjectId = t.codec('ObjectId', (id) => {
    assertObjectId(id);
    return id.toHexString();
}, (id) => {
    assertObjectId(id);
    return new bson.ObjectId(id);
});
const assertObjectWithField = (field, data) => {
    if (typeof data !== 'object') {
        throw new t.TransformError([`Expected an object but got ${typeof data}`]);
    }
    if (!(field in data)) {
        throw new t.TransformError([`Expected ${field} to be a member of object`]);
    }
};
exports.ResourceId = t.codec('ResourceId', (data) => {
    assertObjectWithField('_id', data);
    return {
        id: exports.ObjectId.encode(data._id)
    };
}, (data) => {
    assertObjectWithField('id', data);
    return {
        _id: exports.ObjectId.decode(data.id)
    };
});
exports.Timestamps = t.object({
    created_at: exports.date,
    updated_at: exports.date
});
exports.Resource = exports.ResourceId.and(exports.Timestamps);
exports.QueryFilter = t.object({
    exists: t.boolean
});
const makeQueryFilter = (type) => {
    return type.or(t.array(type)).or(exports.QueryFilter).optional();
};
exports.makeQueryFilter = makeQueryFilter;
const FilterProperties = (type) => {
    let codecs = new Map();
    const addCodecs = (codec) => {
        if (codec.props?.shape) {
            Object.keys(codec.props.shape).forEach((k) => {
                codecs.set(k, codec.props.shape[k]);
            });
        }
    };
    if (type._tag === t.CodecType.Object) {
        addCodecs(type);
    }
    else if (type._tag === t.CodecType.Intersection) {
        type.props.codecs.forEach((c) => {
            addCodecs(c);
        });
    }
    t.object({
        test: t.string
    });
    // @ts-ignore
    return t.object(Array.from(codecs.keys()).reduce((prev, cur) => {
        prev[cur] = (0, exports.makeQueryFilter)(codecs.get(cur));
        return prev;
    }, {}));
};
exports.FilterProperties = FilterProperties;
